import React from 'react';
import { getCreativeSharingIcon } from 'packages/pages/components/card/utils';
import { IdentityRole } from 'packages/store/sharing/types';
import TemplateCardBase, { type TemplateCardBaseProps } from './TemplateCardBase';
import { HiddenActions, MenuActions } from '../TemplateContextMenu/types';
import useAccessRights from 'packages/hooks/useAccessRights';
import roles from 'packages/configs/roles';
import TemplateContextMenu from '../TemplateContextMenu';
import { PreviewActionButton } from './PreviewActionButton';

export type TemplateCardProps = Omit<
    TemplateCardBaseProps,
    'testId' | 'selectButtonAriaLabel' | 'contextAction' | 'headerIcon'
> & {
    menuActions: MenuActions;
    hiddenMenuActions?: HiddenActions;
    includeSharedIndicator?: boolean;
    isOverview?: boolean;
    onContextMenuTriggerClick?: () => void;
};

export const TemplateCard = ({
    template,
    menuActions,
    hiddenMenuActions = [],
    isSelected,
    onSelect,
    onClick,
    includeSharedIndicator,
    isOverview = false,
    onContextMenuTriggerClick,
}: TemplateCardProps) => {
    const { isAccountRoleAssigned } = useAccessRights();
    const headerIcon = includeSharedIndicator && getCreativeSharingIcon(template, true, IdentityRole.CAN_USE);

    return (
        <TemplateCardBase
            template={template}
            isSelected={isSelected}
            onSelect={onSelect}
            onClick={onClick}
            selectButtonAriaLabel={`Select template ${template.name}`}
            testId="template_card"
            contextAction={
                isAccountRoleAssigned(roles.video_brand_studio.video.manage) ? (
                    <PreviewActionButton template={template} onClick={menuActions.showPreview} />
                ) : (
                    <TemplateContextMenu
                        template={template}
                        menuActions={menuActions}
                        hiddenActions={hiddenMenuActions}
                        onContextMenuTriggerClick={onContextMenuTriggerClick}
                        isOverview={isOverview}
                        isCardAction
                    />
                )
            }
            headerIcon={headerIcon}
        />
    );
};
